import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash',
  routes: [
    {
      path: '/',
      name: 'Landing',
      component: () => import('../components/Landing.vue')
    },
    {
      path: '/Login',
      name: 'Login',
      component: () => import('../components/Login.vue')
    },
    {
      path: '/ChangePassword',
      name: 'ChangePassword',
      component: () => import('../components/ChangePassword.vue')
    },
    {
      path: '/GyeonggidoBabyBoomer',
      name: 'GyeonggidoBabyBoomer',
      component: () => import('../components/project/GyeonggidoBabyBoomer.vue')
    },
    {
      path: '/Index',
      name: 'Index',
      component: () => import('../components/Index.vue')
    },
    {
      path: '',
      name: 'Main',
      component: () => import('../components/Main.vue'),
      children: [
        {
          path: '/SubMenu11',
          name: 'SubMenu11',
          component: () => import('../components/content/menu1/SubMenu11.vue')
        },
        {
          path: '/SubMenu12',
          name: 'SubMenu12',
          component: () => import('../components/content/menu1/SubMenu12.vue')
        },
        {
          path: '/SubMenu13',
          name: 'SubMenu13',
          component: () => import('../components/content/menu1/SubMenu13.vue')
        },
        {
          path: '/SubMenu14',
          name: 'SubMenu14',
          component: () => import('../components/content/menu1/SubMenu14.vue')
        },
        {
          path: '/SubMenu15',
          name: 'SubMenu15',
          component: () => import('../components/content/menu1/SubMenu15.vue')
        },
        {
          path: '/SubMenu21',
          name: 'SubMenu21',
          component: () => import('../components/content/menu2/SubMenu21.vue')
        },
        {
          path: '/SubMenu22',
          name: 'SubMenu22',
          component: () => import('../components/content/menu2/SubMenu22.vue')
        },
        {
          path: '/SubMenu23',
          name: 'SubMenu23',
          component: () => import('../components/content/menu2/SubMenu23.vue')
        },
        {
          path: '/SubMenu31',
          name: 'SubMenu31',
          component: () => import('../components/content/menu3/SubMenu31.vue')
        },
        {
          path: '/SubMenu32',
          name: 'SubMenu32',
          component: () => import('../components/content/menu3/SubMenu32.vue')
        },
        {
          path: '/SubMenu33',
          name: 'SubMenu33',
          component: () => import('../components/content/menu3/SubMenu33.vue')
        },
        {
          path: '/SubMenu34',
          name: 'SubMenu34',
          component: () => import('../components/content/menu3/SubMenu34.vue')
        },
        {
          path: '/SubMenu41',
          name: 'SubMenu41',
          component: () => import('../components/content/menu4/SubMenu41.vue')
        },
        {
          path: '/SubMenu42',
          name: 'SubMenu42',
          component: () => import('../components/content/menu4/SubMenu42.vue')
        },
        {
          path: '/SubMenu43',
          name: 'SubMenu43',
          component: () => import('../components/content/menu4/SubMenu43.vue')
        },
        {
          path: '/SubMenu44',
          name: 'SubMenu44',
          component: () => import('../components/content/menu4/SubMenu44.vue')
        },
        {
          path: '/SubMenu51',
          name: 'SubMenu51',
          component: () => import('../components/content/menu5/SubMenu51.vue')
        },
        {
          path: '/SubMenu52',
          name: 'SubMenu52',
          component: () => import('../components/content/menu5/SubMenu52.vue')
        },
        {
          path: '/SubMenu53',
          name: 'SubMenu53',
          component: () => import('../components/content/menu5/SubMenu53.vue')
        },
        {
          path: '/SubMenu54',
          name: 'SubMenu54',
          component: () => import('../components/content/menu5/SubMenu54.vue')
        },
        {
          path: '/SubMenu55',
          name: 'SubMenu55',
          component: () => import('../components/content/menu5/SubMenu55.vue')
        },
        {
          path: '/SubMenu55View',
          name: 'SubMenu55View',
          component: () => import('../components/content/menu5/SubMenu55View.vue')
        },
        {
          path: '/SubMenu56',
          name: 'SubMenu56',
          component: () => import('../components/content/menu5/SubMenu56.vue')
        },
        {
          path: '/SubMenu57',
          name: 'SubMenu57',
          component: () => import('../components/content/menu5/SubMenu57.vue')
        },
        {
          path: '/SubMenu61',
          name: 'SubMenu61',
          component: () => import('../components/content/menu6/SubMenu61.vue')
        },
        {
          path: '/SubMenu61View',
          name: 'SubMenu61View',
          component: () => import('../components/content/menu6/SubMenu61View.vue')
        },
        {
          path: '/SubMenu62',
          name: 'SubMenu62',
          component: () => import('../components/content/menu6/SubMenu62.vue')
        },
        {
          path: '/SubMenu63',
          name: 'SubMenu63',
          component: () => import('../components/content/menu6/SubMenu63.vue')
        },
        {
          path: '/SubMenu71',
          name: 'SubMenu71',
          component: () => import('../components/content/menu7/SubMenu71.vue')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js